import React from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

class Panel extends React.Component {
  render() {
    const { classes, title, rightPanel, noSpacing, style } = this.props;
    return (
      <div className={classes.outerStyle} style={style}>
        <Paper className={classes.paperStyle} square={true}>
          {title && (
            <Typography className={classes.titleStyle} variant="h5">
              {title}
              {rightPanel && (
                <div className={classes.rightStyle}>{rightPanel}</div>
              )}
            </Typography>
          )}
          <div
            className={classNames(classes.contentStyle, {
              [classes.spacing]: !noSpacing
            })}
          >
            {this.props.children}
          </div>
        </Paper>
      </div>
    );
  }
}

const styles = theme => ({
  outerStyle: {
    height: "inherit",
    width: "100%",
    padding: "32px 16px 36px 16px"
  },
  paperStyle: {
    height: "100%",
    position: "relative"
  },
  titleStyle: {
    borderBottom: "1px solid lightgrey",
    padding: theme.spacing(2),
    color: theme.palette.primary.main,
    fontWeight: "bold"
  },
  contentStyle: {
    overflowY: "auto",
    maxHeight: "calc(100% - 66px)"
  },
  spacing: {
    padding: theme.spacing(2)
  },
  rightStyle: {
    position: "absolute",
    right: "6px",
    top: "12px"
  }
});

export default withStyles(styles)(Panel);
